<template>
  <div id="app">
    <div class="row" v-if="this.data_store.products.length">
      <div class="col-12 col-md-8 product-list">

        <div v-if="noSectionsShowing" class="no-results">
          <h3>{{ this.data_store.empty_list_message }}</h3>
        </div>

        <product-section v-for="section in visibleSections(sections)" :key="section.name" :section="section"
          :sub_sections="visibleSubSections(section)" :products="productsToShow()"></product-section>
      </div>

      <!-- FILTERS -->
      <div class="col-12 col-md-4 product-filters">
        <filter-block v-for="filter in filterSections()" :key="filter.name" :filter="filter"
          :filterItems="getFilterItems(filter.name)" @filterChange="updateAppliedFilters"></filter-block>
        <div class="card border-0" v-if="sidebarLinks.length">
          <div class="card-header border-0 rounded-0">
            <h3 class="mb-0 fs-5 text-white">
              <span class="fas fa-filter mr-2 fs-6" aria-hidden="true"></span>
              Browse by {{ this.data_store.sidebar.title }}
            </h3>
          </div>
          <div class="card-body bg-gray-100">
            <ul class="list-unstyled text-decoration-underline">
              <li v-for="(link, index) in sidebarLinks" :key="index"><a :href="link.url">{{ link.text }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="this.data_store.is_loading" class="d-flex align-items-center w-100">
      <strong>Loading...</strong>
      <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
    </div>
    <div v-else>
      <p class='m-0 my-3 fs-5'><strong>No products found matching your criteria.</strong></p>
      <div v-if="bci_group_filter && cca_filter">
        <p class='m-0 mt-3 fs-6'>
          Here, you can find detailed information about the battery that is compatible with your vehicle:
        </p>
        <p class='m-0 mt-5 fs-6'>Battery size: {{ bci_group_filter }}</p>
        <p class='m-0 mt-1 fs-6'>CCA: {{ cca_filter }}</p>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from "axios"
    import FilterBlock from "./components/FilterBlock.vue";
    import ProductSection from "./components/ProductSection.vue";

    export default {
        name: 'app',
        components: {
            ProductSection,
            FilterBlock
        },
        data(){
            return {
                data_store: {
                    browse_method: '',
                    subset_id: '',
                    subset_name: '',
                    subset_description: '',
                    subset_image: '',
                    sections: [],
                    products: [],
                    filter_sections: [],
                    applied_filters: {},
                    sidebar: [],
                    empty_list_message: '',
                    is_loading: true,
                }
            }
        },
        created(){
            this.data_store.is_loading = true;
            if(
                (typeof subset_dialogs != 'undefined' && subset_dialogs > 0)
                && (typeof browse_method_dialogs != 'undefined' && browse_method_dialogs != '')
            ) {
                axios.post(
                    'https://devcontbatt.dialogs1.com/endpoints/App_Get_Products.html',
                    {
                        browse_method: browse_method_dialogs,
                        subset_id: subset_dialogs,
                        p_year: p_year,
                        p_make: p_make,
                        p_model: p_model,
                        p_engine: p_engine,
                        p_catalog: p_catalog,
                        new_method: p_new_method
                    }
                ).then(response => {
                    this.data_store = response.data;
                });
            } else {
                // eslint-disable-next-line
                console.log('Missing required variables for product browser - Find your battery');
            }
			this.data_store.is_loading = false;
        },
        computed: {

            bci_error(){
                return bci_error;
            },

            bci_groups_not_empty(){
                if(bci_group_filter.length) {
                    return true;
                } else {
                    return false;
                }
            },

            sections(){
                return this.data_store.sections.map(section => {

                    let name = section.name;
                    let description = section.description;
                    let sub_sections = section.sub_sections;
                    return {
                        name: name,
                        description: description,
                        sub_sections: sub_sections
                    }
                })
            },

            sidebarLinks(){
                return this.data_store.sidebar.links;
            },

            noSectionsShowing(){
                if(this.visibleSections(this.sections).length == 0){
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            productsToShow(){
                if(this.bci_error){
                    this.data_store.empty_list_message = 'Sorry, no products were found for your vehicle.';
                    return [];
                }

                if(this.bci_groups_not_empty){
                    this.data_store.empty_list_message = 'Sorry, no products were found for your vehicle.';
                } else {
                    this.data_store.empty_list_message = 'Sorry, no products match your criteria.';
                }

                return this.data_store.products.filter(product => {

                    let cat_filter = typeof this.data_store.applied_filters.categories != 'undefined' ? this.data_store.applied_filters.categories : [];
                    let man_filter = typeof this.data_store.applied_filters.manufacturer != 'undefined' ? this.data_store.applied_filters.manufacturer : [];
                    let volt_filter = this.data_store.applied_filters.voltage;

                    // bci_group_filter and cca_filter are used for automotive battery finder and are set in js
                    // on the dialogs page that includes the Vue app
                    let bci_group_match = this.bci_groups_not_empty ? bci_group_filter.includes(product.bci_group) : true;
                    // product is a match if it's cca value is larger than the lowest cca value in cca_filter
                    let cca_match = cca_filter.length ? Math.min(...cca_filter) <= product.cca : true;



                    let category_intersection = cat_filter.length ? cat_filter.filter(value => product.categories.includes(value)) : [1];
                    let manufacturer_match = man_filter.length ? man_filter.includes(product.manufacturer) : true;
                    let voltage_match = volt_filter.length ? volt_filter.includes(product.voltage) : true;

                    if(category_intersection.length && manufacturer_match && voltage_match && bci_group_match && cca_match){
                        return product;
                    }
                });
            },

            filterSections(){
                return this.data_store.filter_sections.filter(filter => this.getFilterItems(filter.name).length);
            },

            // consider replacing forEach with map
            getFilterItems(filter_name){
                let filter_items = [];
                this.data_store.products.forEach(product => {
                    if(typeof product[filter_name] != 'object'){
                        if(product[filter_name] != '' && product[filter_name] != '&nbsp;' && !filter_items.includes(product[filter_name])){
                            filter_items.push(product[filter_name]);
                        }
                    } else {
                        product[filter_name].forEach(e => {
                            if(e != '' && e != null && e != '&nbsp;' && !filter_items.includes(e)){
                                filter_items.push(e);
                            }
                        });
                    }
                });
                return filter_items;
            },

            updateAppliedFilters(value){
                if(typeof this.data_store.applied_filters != 'undefined') {
                    if (!this.data_store.applied_filters[value.filter].includes(value.item)) {
                        this.data_store.applied_filters[value.filter].push(value.item);
                    } else {
                        this.data_store.applied_filters[value.filter].forEach((item, index) => {
                            if (item === value.item) {
                                this.data_store.applied_filters[value.filter].splice(index, 1);
                            }
                        })
                    }
                }
            },

            visibleSections(sections){
                let visible_sections = [];
                sections.forEach(section => {
                    let visible_sub_sections = this.visibleSubSections(section);
                    section.sub_sections.forEach(sub_section => {
                       if(visible_sub_sections.includes(sub_section) && !visible_sections.includes(section)){
                           visible_sections.push(section);
                       }
                    });
                });
                return visible_sections;
            },

            visibleSubSections(section){
                let visible_sub_sections = [];
                this.productsToShow().forEach(product => {
                    product.show_in_sub_sections.forEach(sub_section => {
                        if(!visible_sub_sections.includes(sub_section) && section.sub_sections.includes(sub_section)) {
                            // the computed sections object has sub-sections in the correct order so match those indexes
                            let index = section.sub_sections.indexOf(sub_section);
                            visible_sub_sections[index] = sub_section;
                        }
                    });
                });
                // will have empty elements due to possible missing indexes so filter them out
                return this.filterEmptyElements(visible_sub_sections);
            },

            filterEmptyElements(array){
                return array.filter(function (element) {
                    return element != null;
                });
            }
        }
    }
</script>

<style></style>
